﻿import { Window } from '@progress/kendo-react-dialogs';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router';
import { MessageType } from '../../services/actor-messages';
import { NoteCategory } from '../../types/notes';
import { useEvent } from '../contexts/event-bus';
import Notes, { OpenNotesCommand } from '../features/home/flyouts/Notes';
import { useFlightWorker } from '../hooks/use-flight-worker';

function NotesWindow() {
    const [notesCommand, setNotesCommand] = React.useState<OpenNotesCommand | null>(null);
    const worker = useFlightWorker();
    const location = useLocation();

    const handleShowNotesWindow = React.useCallback(
        async (command: OpenNotesCommand) => {
            if (command.category === NoteCategory.aircraft && command.flightId) {
                const flightDetails = await worker.actor.sendAsync({ type: MessageType.getFlight, data: command.flightId });
                setNotesCommand({ ...command, flight: flightDetails ?? undefined });
                return;
            }
            setNotesCommand(command);
        },
        [worker]
    );

    useEffect(() => {
        if (notesCommand) {
            setNotesCommand(null);
        }
    }, [location]);

    useEvent('show-notes-window', handleShowNotesWindow);

    return (
        <>
            {notesCommand && (
                <Window
                    className={'note-window'}
                    height={500}
                    width={682}
                    title={`${notesCommand?.itemId} Notes`}
                    onClose={() => setNotesCommand(null)}>
                    <Notes
                        itemId={notesCommand.itemId}
                        additionalItemId={notesCommand.flight?.regId ?? undefined}
                        category={notesCommand.category}
                        flight={notesCommand.flight}
                    />
                </Window>
            )}
        </>
    );
}

export default NotesWindow;
